import { render, staticRenderFns } from "./recallRetrieveCheckAction.vue?vue&type=template&id=2b0a53b0&scoped=true"
import script from "./recallRetrieveCheckAction.vue?vue&type=script&lang=js"
export * from "./recallRetrieveCheckAction.vue?vue&type=script&lang=js"
import style0 from "./recallRetrieveCheckAction.vue?vue&type=style&index=0&id=2b0a53b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a53b0",
  null
  
)

export default component.exports